export const AFFILIATE_PROGRAM_PROMO_CODES_CREATE_ROUTE_NAME = Symbol('affiliate-program.promo-codes.create');

export const AFFILIATE_PROGRAM_PROMO_TRACKERS_LIST_QUERY_KEY = 'affiliate-program.promo-codes.trackers';

export const AFFILIATE_PROGRAM_PROMO_TRACKERS_LIST_API_URL = 'admin/promo_codes/list_trackers';
export const AFFILIATE_PROGRAM_PROMO_CODES_CREATE_URL = 'admin/promo_codes';

export const AFFILIATE_PROGRAM_PROMO_CODES_CREATE_MUTATION_KEY = 'affiliate-program.promo-codes.create';
